import { useParams } from "react-router-dom";

import { Layout } from "Layout";

import { ListPage } from "components/ListPage/ListPage";

import { i18n } from "services/i18nService";

import { useEditModal } from "hooks/useEditModal";
import { usePrivileges } from "hooks/usePrivileges";

import { Forbidden } from "Forbidden";
import { OBJECT_TYPES, USER_PRIVILEGE } from "appConstants";

const objectType = OBJECT_TYPES.SALES_ORDER.fullString;

export function SalesOrderList() {
  const { id } = useParams();

  const { hasPrivilegesOrIsAdmin } = usePrivileges();
  const allowList = hasPrivilegesOrIsAdmin([
    USER_PRIVILEGE.viewSalesOrders,
    USER_PRIVILEGE.editSalesOrders,
  ]);

  useEditModal(objectType, id);

  return (
    <Layout pageTitle={i18n(`objectType.${objectType}.SentencePlural`)}>
      {allowList ? <ListPage objectType={objectType} /> : <Forbidden />}
    </Layout>
  );
}
